import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AddTaskSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AddTaskSVG;
